module.exports = __webpack_public_path__ + "static/media/Venezuela.0ad4060d.png";